<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-12 d-block d-md-none">
            <router-link
              :to="'/'"
              class="btn-link font-weight-normal text-white"
              title="Voltar para o início"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-4 mb-2">
              Aqui você pode conferir a gerenciar os arquivos internos e a nuvem
              de documentos a ser disponibilizada para os colaboradores. Todos
              os arquivos são sincronizados com a conta do Dropbox vinculada no
              painel abaixo.
            </p>
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">
          <div class="card shadow">
            <div class="card-header">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">Arquivos</h3>
                </div>
              </div>
            </div>
            <div
              class="card-body pt-0 pt-md-4 pb-1 vld-parent"
              ref="card_new_file"
            >
              <div class="row">
                <div class="col-12 mt-1 mb-2 text-center">
                  <file-select
                    v-model="model.file"
                    title="Adicionar aquivo"
                    type="dark"
                    accept="image/*pdf/*"
                    :mbSize="20"
                  ></file-select>
                  <br />
                  <div v-if="model.file">
                    <p class="description mt-2">
                      <i class="fas fa-info-circle mr-1" /> Se desejar, é
                      possível definir o nome de uma pasta a ser criada no
                      diretório atual ({{ currentPath || "/" }}) para manter o
                      arquivo. Se não especificado, o arquivo será armazenado
                      dentro da pasta atual.
                    </p>
                    <base-input
                      v-model="newFolder"
                      addon-left-icon="fas fa-folder"
                      placeholder="Digite o nome da nova pasta (opcional)"
                    />
                    <button
                      :disabled="!modalEditToken.initialToken"
                      @click="handleSubmitFile()"
                      :class="[
                        { jump: modalEditToken.initialToken },
                        'btn btn-primary my-2 m-1'
                      ]"
                    >
                      Salvar arquivo
                    </button>
                  </div>
                </div>
                <div class="col-12" v-if="errorSubmitFile">
                  <base-alert type="danger" class="text-center">
                    {{ errorSubmitFile }}
                  </base-alert>
                </div>
                <div class="col-12">
                  <p class="text-sm text-muted text-center">
                    <i class="fas fa-info-circle mr-1"></i> Os arquivos devem
                    possuir tamanho máximo de 20MB e, preferencialmente, serem
                    dos formatos <b>office-like</b>, <b>PDF</b>, <b>PNG</b> ou
                    <b>JPG</b> com dimensão de <b>500x500 pixels</b>.
                  </p>
                </div>
              </div>
            </div>
            <div class="card-footer text-center">
              <i class="fas fa-globe fa-2x text-primary d-block"></i>
              <p class="lead mt-3">Atenção: Compartilhamento de arquivos</p>
              <p>
                <i class="fas fa-arrow-right mr-1"></i> Todos os arquivos no
                diretório raiz (/) dentro da pasta <b>/Colaboradores</b> estarão
                visíveis na nuvem de documentos dos colaboradores da empresa.
              </p>
            </div>
          </div>
        </div>
        <div class="col-xl-8 order-xl-1">
          <div class="card shadow pb-2">
            <div class="card-header align-items-center">
              <div class="row">
                <div class="col-12">
                  <h5 class="h3">
                    Nuvem de documentos da empresa
                    <base-button
                      type="link"
                      :iconOnly="true"
                      title="Alterar token"
                      @click="handleOpenModalEditToken()"
                      class="float-right mt--2"
                      icon="fas fa-ellipsis-v"
                    >
                    </base-button>
                  </h5>
                </div>
              </div>
            </div>
            <div class="card-body vld-parent" ref="documents_list">
              <div class="row mb-2">
                <div class="col-12 text-left">
                  <div
                    v-for="(folder, index) in folders"
                    :key="index"
                    class="d-inline-block"
                  >
                    <base-button
                      type="link"
                      class="p-0 m-0 mt--1"
                      @click="handlePrevious(index)"
                    >
                      <span
                        v-if="folder.name"
                        :title="`Ir para ${folder.name}`"
                        >{{ folder.name }}</span
                      >
                      <span v-else title="Ir para /"
                        ><i class="fas fa-home mt--1"></i
                      ></span>
                    </base-button>
                    <i class="fas fa-angle-right mx-3"></i>
                  </div>
                </div>
              </div>
              <div v-if="errorFetch">
                <p class="text-center text-warning">
                  {{ errorFetch }}
                  <br />
                  <base-button
                    type="primary"
                    :custom="true"
                    size="sm"
                    class="mt-2"
                    @click="handleOpenModalEditToken()"
                    ><i class="fab fa-dropbox mr-1"></i> Configurar
                    token</base-button
                  >
                </p>
              </div>
              <div v-else-if="emptyFiles">
                <p class="text-center text-warning mt-5">
                  Nenhum diretório ou arquivo foi encontrado.
                </p>
              </div>
              <div v-else>
                <div class="row">
                  <div
                    v-for="(file, index) in files"
                    :key="index"
                    class="col-lg-3 col-md-6 col-sm-6 col-xl-3 p-0"
                  >
                    <div class="p-4" v-if="file['.tag'] == 'folder'">
                      <button
                        class="btn btn-lg btn-link btn-block"
                        @click="handleNext(file.name)"
                      >
                        <i
                          class="
                            fas
                            fa-folder-open fa-3x
                            mb-2
                            d-block
                            text-black
                          "
                        ></i>
                        {{ file.name }}
                      </button>
                    </div>
                    <div class="p-4" v-else>
                      <button
                        @click="handleOpenFile(file.name)"
                        class="btn btn-lg btn-block btn-link"
                      >
                        <i
                          class="far fa-file-alt fa-3x mb-2 d-block text-black"
                        ></i>
                        {{ file.name }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      :show.sync="modalEditToken.show"
      modal-classes="modal-dialog-centered"
      body-classes="pb-0"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Token de acesso
      </h6>
      <div class="vld-parent">
        <div class="pb-3 text-center">
          <i class="fab fa-dropbox fa-3x"></i>
          <h5 class="heading mt-2">Configurar token de acesso</h5>
        </div>
        <div class="vld-parent" ref="modal_edit_token">
          <div class="py-3">
            <div class="row">
              <div class="col-lg-12">
                <label class="form-control-label d-block">Dropbox token</label>
                <base-input
                  type="text"
                  v-model="model.token"
                  placeholder="Cole o token de acesso aqui"
                  addon-left-icon="fas fa-key"
                />
              </div>
              <div class="col-lg-12" v-if="modalEditToken.initialToken">
                <hr class="my-4" />

                <p class="text-sm text-center text-muted text-break">
                  <b class="text-dark">Token atual:</b>
                  {{ modalEditToken.initialToken.token }}
                </p>
                <hr class="my-4" />
              </div>
            </div>
            <base-alert
              type="danger"
              class="text-center"
              v-if="modalEditToken.error"
            >
              {{ modalEditToken.error }}
            </base-alert>
          </div>
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="dark"
          class="ml-auto"
          @click="modalEditToken.show = false"
        >
          Voltar
        </base-button>
        <base-button
          @click="handleSaveToken()"
          type="default"
          :disabled="!model.token"
        >
          Salvar
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "empresa-documentos",
  data() {
    return {
      model: {
        token: "",
        file: null
      },
      newFolder: "",
      folders: [],
      files: [],
      currentPath: "",
      emptyFiles: "",
      errorFetch: "",
      errorSubmitFile: "",
      modalEditToken: {
        show: false,
        initialToken: "",
        error: ""
      }
    };
  },
  async mounted() {
    await this.loadToken();
    await this.fetchFiles();
    this.folders = [{ name: "" }];
  },
  methods: {
    async loadToken() {
      try {
        const { data } = await api.get("/company/documents/dropbox-tokens");
        this.modalEditToken.initialToken = data;
      } catch (e) {
        this.modalEditToken.initialToken = false;
      }
    },
    async fetchFiles(path = "", callback = "") {
      this.errorFetch = this.emptyFiles = false;
      this.files = this.folder = [];
      const loader = this.$loading.show({
        container: this.$refs.documents_list,
        width: 90,
        height: 90
      });
      try {
        const { data } = await api.get(`/company/documents/drive/${path}`);
        if (!data) throw new Error();
        if (data.missingToken) {
          this.errorFetch = "Token de acesso da empresa não foi encontrado.";
          this.$toasted.error("Token de acesso não encontrado");
        } else {
          if (data.result && data.result.entries.length)
            this.files = data.result.entries;
          else this.emptyFiles = true;
          if (callback) callback();
        }
      } catch (e) {
        this.errorFetch =
          "Ocorreu um erro ao carregar os arquivos. Verifique seu token de acesso.";
        this.$toasted.error(this.error);
      }
      loader.hide();
    },
    async handleSaveToken() {
      const loader = this.$loading.show({
        container: this.$refs.modal_edit_token,
        opacity: 0,
        width: 140,
        height: 140
      });
      try {
        const { data } = await api.post("/company/documents/dropbox-tokens", {
          token: this.model.token
        });
        this.$toasted.show("Token de acesso salvo com sucesso");
        this.modalEditToken.show = false;
        this.modalEditToken.initialToken = data;
        await this.fetchFiles();
      } catch (e) {
        const genericError =
          "Ocorreu um erro ao salvar o token. Tente novamente.";
        const hasErrorResponseData = e.response && e.response.data;
        let customError = genericError;
        if (hasErrorResponseData) {
          const data = e.response.data.error
            ? e.response.data.error
            : e.response.data.errors;
          if (data[0] && data[0].message) customError = data[0].message;
          else if (data.message) customError = data.message;
        }
        this.modalEditToken.error = hasErrorResponseData
          ? customError
          : genericError;
        this.$toasted.error(
          "Ocorreu um erro ao salvar o token. Tente novamente."
        );
      } finally {
        loader.hide();
      }
    },
    handleOpenModalEditToken() {
      this.model.token = "";
      this.modalEditToken.error = "";
      this.modalEditToken.show = true;
    },
    async handleNext(name) {
      const targetPath = this.currentPath + "/" + name;
      await this.fetchFiles(targetPath ? `?query=${targetPath}` : "", () => {
        this.folders.push({ name: name });
        this.currentPath = targetPath;
      });
    },
    async handlePrevious(index) {
      let targetPath = "";
      const folders = [{ name: "" }];
      for (let i = 1; i <= index; i++) {
        targetPath += "/" + this.folders[i].name;
        folders.push(this.folders[i]);
      }
      await this.fetchFiles(targetPath ? `?query=${targetPath}` : "", () => {
        this.folders = folders;
        this.currentPath = targetPath;
      });
    },
    async handleOpenFile(name) {
      const loader = this.$loading.show({
        container: this.$refs.documents_list,
        width: 90,
        height: 90
      });
      try {
        const targetFile = this.currentPath + "/" + name;
        const { data } = await api.get(
          `/company/documents/drive/show?path=${targetFile}`
        );
        if (!data.result) throw new Error();
        window.open(
          data.result.url,
          "file-window",
          "resizable=1,height=750,width=750"
        );
        this.$toasted.show("Abrindo arquivo");
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao obter o arquivo");
        window.open(
          `https://www.dropbox.com/home${this.currentPath}?preview=${name}`,
          "file-window",
          "resizable=1,height=750,width=750"
        );
      }
      loader.hide();
    },
    async handleSubmitFile() {
      this.errorFetch = this.success = "";
      const loader = this.$loading.show({
        container: this.$refs.card_new_file,
        width: 90,
        height: 90
      });
      const file = this.model.file;
      if (!file) return;
      const data = new FormData();
      data.append("file", file, file.name);
      const path = this.newFolder
        ? `${this.currentPath}/${this.newFolder}`
        : this.currentPath;
      data.append("path", path);
      const config = {
        headers: {
          "content-type": "multipart/form-data"
        }
      };
      try {
        await api.post("/company/documents/drive", data, config);
        this.$toasted.show("Arquivo salvo com sucesso");
        this.model.file = null;
        if (this.newFolder) {
          this.currentPath = path;
          this.newFolder.split("/").forEach(subPath => {
            this.folders.push({ name: subPath });
          });
          this.newFolder = "";
        }
        await this.fetchFiles(
          this.currentPath ? `?query=${this.currentPath}` : ""
        );
      } catch (e) {
        const genericError =
          "Ocorreu um erro ao salvar o arquivo. Tente novamente.";
        const hasErrorResponseData = e.response && e.response.data;
        let customError = genericError;
        if (hasErrorResponseData) {
          const data = e.response.data.error
            ? e.response.data.error
            : e.response.data.errors;
          if (data[0] && data[0].message) customError = data[0].message;
          else if (data.message) customError = data.message;
        }
        this.errorSubmitFile = hasErrorResponseData
          ? customError
          : genericError;
        this.$toasted.error(this.errorSubmitFile);
      }
      loader.hide();
    }
  }
};
</script>
<style scoped>
.jump {
  animation: jump 1.5s 0s forwards cubic-bezier(0.84, -0.54, 0.31, 1.19)
    infinite;
}

@keyframes jump {
  0% {
    transform: none;
  }
  50% {
    transform: translateY(-2em);
  }
}

.text-black {
  color: #525f7f;
}
</style>
